export const formatPhoneNumber = (value) => {
  // Remove all non-numeric characters
  const phoneNumber = value.replace(/\D/g, '');
  
  // Format based on length
  if (phoneNumber.length === 0) {
    return '';
  } else if (phoneNumber.length <= 3) {
    return `(${phoneNumber}`;
  } else if (phoneNumber.length <= 6) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  } else if (phoneNumber.length <= 10) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  } else {
    // Max 10 digits for US phone numbers
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  }
};

export const formatPhoneNumberWithCountryCode = (value) => {
  if (!value) return '';
  
  // Convert to string and remove all non-numeric characters except + at the beginning
  const cleanValue = String(value);
  const hasPlus = cleanValue.startsWith('+');
  const phoneNumber = cleanValue.replace(/\D/g, '');
  
  // Handle US phone numbers (11 digits starting with 1)
  if (phoneNumber.length >= 11 && phoneNumber.startsWith('1')) {
    // Take only first 11 digits for US format
    const usNumber = phoneNumber.slice(0, 11);
    const countryCode = '+1';
    const areaCode = usNumber.slice(1, 4);
    const firstPart = usNumber.slice(4, 7);
    const secondPart = usNumber.slice(7, 11);
    return `${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
  }
  
  // Handle 10 digit numbers (assume US without country code)
  if (phoneNumber.length === 10) {
    const areaCode = phoneNumber.slice(0, 3);
    const firstPart = phoneNumber.slice(3, 6);
    const secondPart = phoneNumber.slice(6);
    return `+1 (${areaCode}) ${firstPart}-${secondPart}`;
  }
  
  // Return original value if format is not recognized
  // Always preserve the + if it was there originally
  if (phoneNumber.length < 10) {
    return hasPlus ? `+${phoneNumber}` : phoneNumber;
  }
  
  return hasPlus ? `+${phoneNumber}` : phoneNumber;
};

export const unformatPhoneNumber = (value) => {
  // Remove all formatting characters
  return value.replace(/\D/g, '');
};